import config from "@/config"
import http from "@/utils/request"
export default {
    findNearByProducts: {
        url: `${config.API_URL}`,
        name: "获取附近商品",
        post: async function (data = {}) {
            return await http.post(`${this.url}/product/user/findNearbyProducts`, { ...data })
        }
    },
    getRequirement: {
        url: `${config.API_URL}`,
        name: "获取资讯列表",
        get: async function (data = {}) {
            return await http.get(`${this.url}/requirement/user/getUserBiddingRequirementList`, data)
        }
    },
    smsCode: {
        url: `${config.API_URL}/smsCode`,
        name: "发送验证码",
        getraphicCaptcha: async function (data = {}) {
            return await http.post(`${this.url}/captcha/getraphicCaptcha`, data)
        },
        sendSmsCode: async function (data = {}) {
            return await http.post(`${this.url}/user/captcha/sendSmsCode`, data)
        }
    }
}
